export default __webpack_public_path__ + "static/media/close.df01555e.svg";